import type { QuoteRequestStatus } from '@repo/api-contracts';

/**
 * 고객이 보는 견적 진행 단계 — 실제 상태(QuoteRequestStatus)가 있는 단계만 둔다.
 * 결제·제작·배송은 주문 통합 전이라 견적 상태로 구분할 수 없어 "주문" 한 단계로 묶는다.
 * 단계 이름은 상태 배지 이름(QUOTE_STATUS_LABELS)과 겹치지 않게 짓는다 — 화면에 같은 글자가 두 번 서지 않게.
 */
export const QUOTE_PROGRESS_STEPS = ['견적 요청', '검토', '견적 발행', '주문'] as const;
export type QuoteProgressStep = (typeof QUOTE_PROGRESS_STEPS)[number];

export interface QuoteProgress {
  /** 지금 머문(또는 멈춘) 단계의 순번 — QUOTE_PROGRESS_STEPS 기준. */
  readonly currentIndex: number;
  /** 거절·반려·취소·만료로 그 단계에서 끝났는지. */
  readonly ended: boolean;
}

const PROGRESS_BY_STATUS: Readonly<Record<QuoteRequestStatus, QuoteProgress>> = {
  REQUESTED: { currentIndex: 1, ended: false },
  // 수정 요청은 운영자가 다시 검토하는 단계로 돌아간다.
  REVISION_REQUESTED: { currentIndex: 1, ended: false },
  ISSUED: { currentIndex: 2, ended: false },
  ORDERED: { currentIndex: 3, ended: false },
  // 발행 전에 끝난 상태는 검토 단계에서, 발행 뒤에 끝난 상태는 발행 단계에서 멈춘다.
  REJECTED: { currentIndex: 1, ended: true },
  CANCELED: { currentIndex: 1, ended: true },
  DECLINED: { currentIndex: 2, ended: true },
  EXPIRED: { currentIndex: 2, ended: true },
};

export const quoteProgressOf = (status: QuoteRequestStatus): QuoteProgress =>
  PROGRESS_BY_STATUS[status];
